// extracted by mini-css-extract-plugin
module.exports = {"EsmaBoxes":"EsmaBoxes_EsmaBoxes__i7J6o","wrapper":"EsmaBoxes_wrapper__hk2am","box":"EsmaBoxes_box__9d_tD","value":"EsmaBoxes_value__kNQn6"};